import { render, staticRenderFns } from "./TkHotelAccess.vue?vue&type=template&id=d0188cc8&"
import script from "./TkHotelAccess.vue?vue&type=script&lang=js&"
export * from "./TkHotelAccess.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelAccess.vue?vue&type=style&index=0&id=d0188cc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports